import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Benefits from './components/Benefits';
import Use from './components/Use';
import Download from './components/Download';
import Footer from './components/Footer'

function App() {
  return (
    <div className="App">
      <Header/>
      <Home/>
      <About/>
      <Benefits/>
      <Use/>
      <Download/>
      <Footer/>
    </div>
  );
}

export default App;
